import * as Scrivito from "scrivito";

const TeaserSliderWidget = Scrivito.provideWidgetClass("TeaserSliderWidget", {
  attributes: {
    nextArrow: "string",
    prevArrow: "string",
    panels: [
      "widgetlist",
      { only: ["TextImagePanelWidget", "EventWidget", "NewsWidget"] },
    ],
  },
});

export default TeaserSliderWidget;
